interface IHelpCenterLinkProps {
  children: string;
}

const HelpCenterLink: React.FC<IHelpCenterLinkProps> = ({ children }) => {
  return (
    <a
      href={children}
      target="_blank"
      rel="noreferrer noopener"
      className="text-secret-purple-default"
    >
      {children}
    </a>
  );
};

export default HelpCenterLink;
